import i18next from 'i18next';
import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {bindActionCreators} from 'redux';
import {autobind} from 'core-decorators';
import {connect} from 'store';
import {getEntitiesGroupedByType} from 'store/element-list/selectors';
import * as actions from 'store/ui/actions';
import {searchEntityFromExploreMenu} from 'store/search/actions';
import Drawer from './drawer';
import EntityType from './entity-type';
import Entity from './entity';

export class EntityMenu extends Component {
    static propTypes = {
        entityTypes: ImmutablePropTypes.list.isRequired,
        opened: PropTypes.bool.isRequired,
        rtl: PropTypes.bool.isRequired,
        entityTypeIndex: PropTypes.number.isRequired,
        toggleEntityMenu: PropTypes.func.isRequired,
        closeEntityMenu: PropTypes.func.isRequired,
        toggleEntityType: PropTypes.func.isRequired,
        searchEntity: PropTypes.func.isRequired,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.entityTypes !== this.props.entityTypes
            || nextProps.opened !== this.props.opened
            || nextProps.rtl !== this.props.rtl
            || nextProps.entityTypeIndex !== this.props.entityTypeIndex
            || nextProps.toggleEntityMenu !== this.props.toggleEntityMenu
            || nextProps.closeEntityMenu !== this.props.closeEntityMenu
            || nextProps.toggleEntityType !== this.props.toggleEntityType
            || nextProps.searchEntity !== this.props.searchEntity;
    }

    @autobind
    handleEntityClick(entity) {
        this.props.closeEntityMenu();
        this.props.searchEntity(entity);
    }

    render() {
        const {opened, rtl, entityTypes, entityTypeIndex} = this.props;

        if (entityTypes.size === 0) return null;

        return (
            <div className='cielo24-vwrap-entity-menu'>
                <Drawer
                    opened={opened}
                    title={i18next.t('Explore')}
                    toggle={this.props.toggleEntityMenu}
                    close={this.props.closeEntityMenu}
                    rtl={rtl}
                >
                    {entityTypes.map(entityType => {
                        const expanded = entityType.get('index') === entityTypeIndex;
                        return (
                            <EntityType
                                key={`entity-type-${entityType.get('index')}`}
                                expanded={expanded}
                                entityType={entityType}
                                tabIndex={opened ? 0 : -1}
                                onClick={this.props.toggleEntityType}
                            >
                                {entityType.get('entities').map(entity => (
                                    <Entity
                                        key={`entity-${entity.get('displayAs')}`}
                                        entity={entity}
                                        tabIndex={expanded ? 0 : -1}
                                        onClick={this.handleEntityClick}
                                    />
                                ))}
                            </EntityType>
                        );
                    })}
                </Drawer>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    entityTypes: getEntitiesGroupedByType(state),
    opened: state.ui.get('entityMenuOpened'),
    rtl: state.config.get('rtl'),
    entityTypeIndex: state.ui.get('entityTypeIndex'),
});

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators(actions, dispatch),
    ...bindActionCreators({searchEntity: searchEntityFromExploreMenu}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EntityMenu);



// WEBPACK FOOTER //
// ./scripts/components/entity-menu/entity-menu.js